import { IdExtractor, type ThumbnailGetter, isHost } from "./ThumbnailGetter";

export function getYoutubeVideoId(s: string): string {
  try {
    const url = new URL(s);
    const host = url.hostname;

    if (host === "youtu.be") {
      return url.pathname.split("/")[1] ?? "";
    }

    if (
      host !== "youtube.com" &&
      host !== "www.youtube.com" &&
      host !== "m.youtube.com"
    ) {
      return "";
    }

    const watchVideoId = url.searchParams.get("v");

    if (watchVideoId) {
      return watchVideoId;
    }

    const pathParts = url.pathname.split("/").filter((part) => {
      return Boolean(part);
    });

    if (pathParts[0] === "shorts") {
      return pathParts[1] ?? "";
    }

    return "";
  } catch {
    return "";
  }
}

export class YoutubeIdExtractor extends IdExtractor {
  get id() {
    return getYoutubeVideoId(this.url);
  }

  static is(s: string): boolean {
    return getYoutubeVideoId(s) !== "" && !isHost(s, "youtu.be");
  }
}

export class YoutubeThumbnailGetter implements ThumbnailGetter {
  idExtractor: YoutubeIdExtractor;
  constructor(url: string) {
    this.idExtractor = new YoutubeIdExtractor(url);
  }

  fetchImgSrc() {
    return Promise.resolve(
      `https://img.youtube.com/vi/${this.idExtractor.id}/hqdefault.jpg`,
    );
  }
}

export class YoutubeShareLinkIdExtractor extends IdExtractor {
  get id() {
    return getYoutubeVideoId(this.url);
  }

  static is(s: string): boolean {
    return isHost(s, "youtu.be");
  }
}

export class YoutubeShareLinkThumbnailGetter implements ThumbnailGetter {
  idExtractor: YoutubeShareLinkIdExtractor;
  constructor(url: string) {
    this.idExtractor = new YoutubeShareLinkIdExtractor(url);
  }

  fetchImgSrc() {
    return Promise.resolve(
      `https://img.youtube.com/vi/${this.idExtractor.id}/hqdefault.jpg`,
    );
  }
}
